<ng-container *ngIf="items?.length > 0">
  <div class="modal-backdrop-custom" (click)="close()"></div>
  <div class="modal-custom" role="dialog" aria-modal="true">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <button type="button" class="close-btn" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="modal-icon">
          <img
            class="icon img-fluid"
            alt="Consultant"
            src="assets/images/icons/alert-icon-warning.png"
          />
        </div>

        <h4 class="modal-title" i18n>Quantity Limit Reached</h4>

        <p class="modal-description" i18n>
          Some items exceeded the maximum allowed quantity, so we've updated them for you.
        </p>
        <p class="modal-sub-description" i18n>
          Please review the changes below before placing your order.
        </p>

        <div class="divider"></div>

        <div class="items-table">
          <div class="item-row" *ngFor="let item of items; let last = last">
            <div class="item-info">
              <span class="item-sku">{{ item.sku }}</span>
              <span class="item-name" *ngIf="item.productName"> - {{ item.productName }}</span>
            </div>
            <div class="item-separator"></div>
            <div class="item-quantities">
              <span class="qty-current" i18n>{{ item.currentQuantity }} in cart</span>
              <span class="qty-reduced" i18n>Reduced cart to {{ item.allowedQuantity }}</span>
            </div>
            <div class="row-divider" *ngIf="!last"></div>
          </div>
        </div>

        <div class="btn-wrapper">
          <button type="button" class="btn-return-to-cart" (click)="close()" i18n>
            RETURN TO CART
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
